var _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "info_svg__a",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 9A8 8 0 1 1 1 9a8 8 0 0 1 16 0Zm-6.06 3.907-.143.58a28.33 28.33 0 0 1-1.018.384 2.69 2.69 0 0 1-.884.132c-.516 0-.917-.126-1.202-.377a1.22 1.22 0 0 1-.43-.958c0-.15.012-.304.033-.46.022-.158.056-.335.103-.533l.529-1.882c.047-.181.087-.352.12-.513.031-.161.048-.309.048-.442 0-.24-.05-.408-.149-.503-.099-.094-.288-.142-.567-.142-.138 0-.278.022-.423.065a5.787 5.787 0 0 0-.37.122l.142-.58c.348-.142.681-.263 1-.364.317-.101.618-.152.902-.152.511 0 .906.124 1.183.37.277.248.416.57.416.965 0 .082-.01.226-.029.432-.02.206-.055.395-.106.567l-.53 1.877c-.042.15-.08.322-.115.516a2.74 2.74 0 0 0-.052.438c0 .25.056.42.168.51.112.09.305.135.58.135.13 0 .275-.022.439-.068a2.43 2.43 0 0 0 .354-.119Zm-.236-7.038c.247-.23.37-.509.37-.835 0-.327-.123-.607-.37-.839a1.258 1.258 0 0 0-.893-.348 1.27 1.27 0 0 0-.896.348c-.25.232-.375.512-.375.839 0 .326.125.605.375.835.249.23.548.345.896.345s.646-.115.893-.345Z",
    fill: "currentcolor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#info_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-16-16h50v50h-50z"
  }))));
};

export default SvgInfo;